<template>
  <v-container fluid>
    <v-card flat style="border-radius: 0">
      <v-card-text>
        <v-layout row wrap>
          <v-flex sm6>
            <h3>CAJERO GN / HISTORIA DE SOLICITUDES ATM</h3>
            <v-tooltip bottom color="info">
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="info" v-on="on" @click="refreshTable()">
                  <v-icon>refresh</v-icon>
                </v-btn>
              </template>
              <span>Refrescar tabla</span>
            </v-tooltip>
            <download-excel :data="json_data" :fields="json_fields">
              <v-btn color="blue-grey" class="white--text">
                <v-icon right dark>assignment_returned</v-icon>Descargar Excel
              </v-btn>
            </download-excel>
          </v-flex>
          <v-flex sm12 xs12 md12 lg12>
            <v-layout row wrap>
              <!--<v-flex xs4 md4 lg4>
                <v-menu
                  v-model="endDatePicker"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formatDate"
                      label="Buscar por fecha de expiración"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker locale="es" v-model="endDate" @input="endDatePicker = false"></v-date-picker>
                </v-menu>
              </v-flex>-->
              <!--<v-flex xs12 md4 lg4>
                <v-select
                  :items="bloques"
                  label="Filtrar Bloque"
                  item-text="bloque"
                  item-value="bloque"
                  v-model="bloque"
                ></v-select>
              </v-flex>-->
              <v-flex xs12 md12 lg12>
                <v-select
                  :items="types"
                  label="Filtrar Tipo"
                  item-text="text"
                  item-value="value"
                  v-model="type"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Buscar por ID ATM..." v-model="agents"></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field label="Buscar por Nombre ATM..." v-model="agentsName"></v-text-field>
              </v-flex>
              <!--<v-flex xs4>
                <v-text-field label="Buscar por Numero de Expediente..." v-model="exp"></v-text-field>
              </v-flex>
               <v-flex xs3>
                <v-text-field label="Buscar por Numero de Serie..." v-model="serie"></v-text-field>
              </v-flex>-->
              <v-flex xs2 >
                <v-btn color="success" block style="margin-top: 13px" @click="getListExpDate()">
                  <v-icon>search</v-icon> Buscar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-data-table
      hide-actions
      :headers="complex.headers"
      :items="complex.items"
      :loading="listLoading"
      :search="search"
    >
      <template v-slot:items="props">
       <!-- <td>{{ props.item.bloque }}</td>-->
        <td>{{ props.item.agent_id }}</td>
        <td>{{ props.item.agents.name }}</td>
        <td>{{ props.item.agents.direction }}</td>
        <td>{{ props.item.agents.district }}</td>
        <td>{{ props.item.agents.province }}</td>
        <td>{{ props.item.agents.department }}</td>
       <!-- <td>{{ props.item.serie }}</td>
        <td>{{ props.item.num }}</td>-->
        <td>{{ props.item.type }}</td>
       <!-- <td>{{ props.item.sign_type }}</td>-->
        <td>{{ props.item.user.email }}</td>
        <td>{{ props.item.created | formatDateHour}}</td>
        <td>
            <a :href="props.item.attachment" target="_blank" v-if="props.item.attachment">
                <v-btn flat icon color="info">
                  <v-icon>camera</v-icon>
                </v-btn>
              </a>
        </td>
        <!--<td>{{ props.item.exp_date | formatDate}}</td>-->
        <td>
          <v-chip :color="getColorP(props.item.status)" dark>{{ props.item.status }}</v-chip>
        </td>
        <td>{{ props.item.observations }}</td>
        <td style="max-width: 225px; min-width: 225px">
          <!--<v-tooltip bottom color="info">
            <template v-slot:activator="{ on }">
              <v-btn flat icon color="info" v-on="on" @click="edit( props.item.id )">
                <v-icon>edit</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>-->
          <v-tooltip bottom color="warning">
            <template v-slot:activator="{ on }">
              <v-btn flat icon color="warning" v-on="on" @click="viewDetail( props.item.id )">
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
            </template>
            <span>Ver detalle</span>
          </v-tooltip>
          <v-tooltip bottom color="error">
            <template v-slot:activator="{ on }">
              <v-btn flat icon color="error" v-on="on" @click="remove( props.item.id )">
                <v-icon>delete</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <v-card flat>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-pagination
          circle
          v-model="pagination.page"
          :length="pagination.page_count"
          @input="changePage"
          @next="changePage"
          @previous="changePage"
        ></v-pagination>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "@/api/axios/config";
import Paginate from "vuejs-paginate";
import moment from "moment";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  components: {
    Paginate
  },
  data() {
    return {
      endDatePicker: false,
      endDate: "",
      agents: "",
      agentsName:"",
      serie: "",
      exp: "",
      bloques: "",
      bloque: "",
      type: "",
      listLoading: false,
      search: "",
      isSearch: false,
      pagination: {
        page_count: null,
        page: 1,
        act_page: 0
      },
      json_fields: {
         //Bloque: "bloque",
        ATM: "agent_id",
        Nombre: "agents.name",
        Dirección: "agents.direction",
        Distrito: "agents.district",
        Provincia: "agents.province",
        Departamento: "agents.department",
        "Documentación": "type",
        /*"Exp. N°": "num",
        "N° Serie": "serie",*/
       // "Tipo de Letrero": "sign_type",
        "Registrado por":"user.name",
        //"Fecha de Solicitud": "request",
        //"Fecha de Entrega": "request_exp",
        "Fecha de Registro": "created",
       // "Fecha de vencimiento": "exp_date",
        Estado: "status",
        Comentarios: "observations"
      },
      json_data: [],
      complex: {
        headers: [
          /*{
            text: "Bloque",
            value: "bloque"
          },*/
          {
            text: "ATM",
            value: "agent_id"
          },
          {
            text: "Nombre",
            value: ""
          },
          {
            text: "Dirección",
            value: ""
          },
          {
            text: "Distrito",
            value: ""
          },
          {
            text: "Provincia",
            value: ""
          },
          {
            text: "Departamento",
            value: ""
          },
          /* {
            text: "N° Serie",
            value: "serie"
          },
          {
            text: "Exp. N°",
            value: "num"
          },*/
          {
            text: "Documentación",
            value: "type"
          },
         /* {
            text: "Tipo de letrero",
            value: "sign_type"
          },*/
          {
            text: "Registrado por",
            value: ""
          },

          {
            text: "Fecha de registro",
            value: "created"
          },

          {
            text: "Imagen",
            value: "attachment"
          },
         /* {
            text: "Fecha de vencimiento",
            value: "exp_date"
          },*/

          {
            text: "Estado",
            value: "status"
          },
          {
            text: "Comentarios",
            value: "observations"
          },
          {
            text: "",
            value: "",
            sortable: false
          }
        ],
        items: []
      },
      types: [
        { value: "DNI", text: "DNI" },
          { value: "LICENCIA LOCAL", text: "Licencia Local" },
          { value: "FOTO FACHADA", text: "Foto Fachada" },
          { value: "AUTORIZACION DEL PROPIETARIO", text: "Autorización del Propietario" },
          { value: "FORMATO DJ", text: "Formato DJ" }
      ]
    };
  },
  filters: {
    formatDate: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD/MM/YYYY");
      }
    },

    formatDateHour: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD/MM/YYYY - hh:mm A");
      }
    }
  },
  computed: {
    formatDate() {
      return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getListExpDate(page = null) {
      this.isSearch = true;
      this.listLoading = true;
      axios
        .get(
          "gn/nueva-data-2?page=" +
            page +
            "&date=" +
            this.endDate +
            "&agents=" +
            this.agents +
            "&agentsName=" +
            this.agentsName +
            "&exp=" +
            this.exp +
            "&serie=" +
            this.serie +
            "&bloque=" +
            this.bloque +
            "&type=" +
            this.type
        )
        .then(response => {
          if (response.data.status) {
            this.complex.items = response.data.items;
            this.bloques = response.data.bloque;
            var pages = 0;
            var numRows = response.data.num_rows;
            var perPage = response.data.per_page;
            pages = parseInt(numRows) / parseInt(perPage);
            this.pagination.page_count = Math.ceil(pages);
          }
        })
        .catch(error => {
          this.snackbar = {
            icon: "error",
            text: error,
            color: "error",
            show: true
          };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    refreshTable() {
      this.pagination = {
        page_count: null,
        page: 1,
        act_page: 0
      };
      this.isSearch = false;
      this.getList();
      this.endDate = "";
    },
    getList(page = null) {
      this.listLoading = true;
      axios
        .get("gn/nueva-data-2?page=" + page)
        .then(response => {
          if (response.data.status) {
            this.complex.items = response.data.items;
            this.json_data = response.data.items;
            this.bloques = response.data.bloque;
            if (this.complex.items.length > 0) {
              var pages = 0;
              var numRows = response.data.num_rows;
              var perPage = response.data.per_page;
              pages = parseInt(numRows) / parseInt(perPage);
              this.pagination.page_count = Math.ceil(pages);
            }
          }
        })
        .catch(error => {
          this.snackbar = {
            icon: "error",
            text: error,
            color: "error",
            show: true
          };
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    changePage() {
      var page = this.pagination.page - 1;
      this.pagination.act_page = page;
      if (this.isSearch) {
        this.getListExpDate(page);
      } else {
        this.getList(page);
      }
    },
    viewDetail(id) {
      this.$router.push("/GN/agente-archivo-gn/ver-detalle-gn/" + id);
    },
    remove(id) {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.listLoading = true;
          axios
            .delete("gn/nueva-data-2/" + id)
            .then(response => {
              if (response.data.status) {
                this.snackbar = {
                  icon: "check_circle",
                  text: "¡Elemento eliminado!",
                  color: "success",
                  show: true
                };
              } else {
                this.snackbar = {
                  icon: "error",
                  text: "Ocurrió un error en el servidor...",
                  color: "error",
                  show: true
                };
              }
            })
            .catch(error => {
              this.snackbar = {
                icon: "error",
                text: error,
                color: "error",
                show: true
              };
            })
            .finally(() => {
              this.listLoading = false;
              this.getList(this.pagination.act_page);
            });
        }
      });
    },
    edit(id) {
      this.$router.push("/GN/agente-archivo-gn/editar-gn/" + id);
    },
    getColorP(status) {
      if (status == "PENDIENTE") return "orange";
      else if (status == "APROBADO") return "info";
      else if (status == "COMPLETADO") return "success";
      else if (status == "RECHAZADO") return "danger";
      else return "info";
    }
  }
};
</script>

<style lang="css">
.pagination {
  list-style: none;
  padding: 0;
}
.pagination li {
  float: left;
}
.pagination li a {
  display: block;
  padding: 0.4rem 0.75rem;
  color: #222;
  margin: 0 0.25rem;
  background: #eee;
  border-radius: 5px;
  box-shadow: 2px 1px 2.5px lightgrey;
  outline: 0;
  transition: ease 0.5s;
}
.pagination li a:active {
  box-shadow: 0 0 0 lightgrey;
}
.pagination li.active a {
  background: #4592af;
  color: #fff;
}
.application a {
    cursor: pointer;
    text-decoration: none;
}
</style> 